<template>
  <div class="plus-bar">
    <div class="plus-content">
      <div class="service-tel">服务热线电话：<span>17716428014</span></div>
      <div class="plus-right">
        <div class="service-tel" @click="onShowMinProg">
          <el-icon :size="15">
            <Paperclip/>
          </el-icon>
          小程序
        </div>
        <div class="service-tel">
          <el-icon :size="15">
            <Warning/>
          </el-icon>
          帮助
        </div>
      </div>
    </div>
  </div>
  <div class="search-box">
    <div class="container">
      <div class="logo">
        <img src="@/assets/images/wlogo.png" alt="蜀志愿">
      </div>
      <div class="right-box">
        <el-input
            v-model="searchVal"
            style="max-width: 400px"
            size="large"
            placeholder="搜资讯/学校/专业/专家"
        >
          <template #append>
            <el-button icon="Search"/>
          </template>
        </el-input>
        <div class="wish-lang">祝广大学子金榜题名</div>
        <div class="open-vip" @click="onOpenVip">开通<span>VIP</span></div>
      </div>
    </div>
  </div>

  <div class="menu-bar">
    <el-menu
        :default-active="activeIndex"
        class="el-menu-bar"
        mode="horizontal"
        background-color="#409eff"
        text-color="#fff"
        active-text-color="#ffd04b"
        router="true"
    >
      <el-menu-item index="home">首页</el-menu-item>
      <el-menu-item index="newsdetail">高考资讯</el-menu-item>
      <el-sub-menu index="3" class="el-sub-menu">
        <template #title>志愿填报</template>
        <el-menu-item index="college">查学校</el-menu-item>
        <el-menu-item index="placequery">查位次</el-menu-item>
        <el-menu-item index="scorequery">一分一段</el-menu-item>
        <el-menu-item index="planlib">招生计划</el-menu-item>
        <el-menu-item index="evaluation">个人测评</el-menu-item>
      </el-sub-menu>
      <!--    <el-sub-menu index="4">-->
      <!--      <template #title>练题库</template>-->
      <!--      <el-menu-item index="4-1">语文</el-menu-item>-->
      <!--      <el-menu-item index="4-2">数学</el-menu-item>-->
      <!--      <el-menu-item index="4-3">英语</el-menu-item>-->
      <!--      <el-menu-item index="4-4">教育类</el-menu-item>-->
      <!--    </el-sub-menu>-->
      <el-menu-item index="majorlib">专业库</el-menu-item>
      <el-menu-item index="expertlist">专家库</el-menu-item>
      <el-menu-item index="about">关于我们</el-menu-item>
    </el-menu>
    <div class="menu-tools">
      <div class="menu-tool-item">
        <el-icon :size="15">
          <Service/>
        </el-icon>
        客服
      </div>
      <div class="user-info" v-if="!store.state.userInfo?.phone">
        <div class="menu-tool-item" @click="onLogin">
          <el-icon :size="15">
            <User/>
          </el-icon>
          登录
        </div>
        <div class="menu-tool-item">|</div>
        <div class="menu-tool-item" @click="onRegister">注册</div>
      </div>
      <div class="u-color" v-else>
        <span>用户：{{ store.state.userInfo.nickname }}</span>
        <el-button type="default" size="small" @click="onLoginOut">退出登录</el-button>
      </div>
    </div>
  </div>
  <!--  <router-view/>-->
  <div
      class="no-select"
      @copy.prevent="handleDisable"
      @cut.prevent="handleDisable"
      @contextmenu.prevent="handleDisable"
  >
    <router-view/>
  </div>
  <FooterBar></FooterBar>

  <el-dialog v-model="showVip" :modal="false" :title="dlgFlag==0?'开通VIP会员':(dlgFlag==1?'官方小程序码':'用户注册')"
             width="250px" top="5vh">
    <div class="tips-box">
      <p v-if="dlgFlag!=1">{{ dlgMessage }}</p>
      <div class="tips-img">
        <img src="@/assets/images/mpcode.png" alt="二维码">
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from 'vue'
import {useStore} from 'vuex';
import {useRouter} from "vue-router";
import {getSysSettings, userLoginOut} from "@/utils";
import FooterBar from "@/components/FooterBar.vue";

const store = useStore()
const router = useRouter()
const activeIndex = ref('1')
const searchVal = ref('')
const showVip = ref(false)
const dlgFlag = ref(0)
const dlgMessage = ref('')

onMounted(() => {
  document.addEventListener('copy', handleDisable);
  document.addEventListener('cut', handleDisable);
  document.addEventListener('contextmenu', handleDisable);
  // document.addEventListener('keydown', handleKeydown);

  let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  if (userInfo) {
    store.commit('updateState', [{key: 'userInfo', value: userInfo}])
  }
  //智能推荐是否免费
  getSysSettings(31).then(res => {
    store.commit('updateState', [{key: 'isFree31', value: res}])
  })
  //位次查询是否免费
  getSysSettings(35).then(res => {
    store.commit('updateState', [{key: 'isFree35', value: res}])
  })
  //一分一段查询是否免费
  getSysSettings(36).then(res => {
    store.commit('updateState', [{key: 'isFree36', value: res}])
  })
  //分数是否免费
  getSysSettings(37).then(res => {
    store.commit('updateState', [{key: 'isFree37', value: res}])
  })
  //计划是否免费
  getSysSettings(52).then(res => {
    store.commit('updateState', [{key: 'isFree52', value: res}])
  })
  //职升专查询是否免费
  getSysSettings(38).then(res => {
    store.commit('updateState', [{key: 'isFree38', value: res}])
  })
  //专升本查询是否免费
  getSysSettings(39).then(res => {
    store.commit('updateState', [{key: 'isFree39', value: res}])
  })
})

onUnmounted(() => {
  document.removeEventListener('copy', handleDisable);
  document.removeEventListener('cut', handleDisable);
  document.removeEventListener('contextmenu', handleDisable);
  // document.removeEventListener('keydown', handleKeydown);
});

const handleDisable = (e) => {
  e.preventDefault();
  return false;
};

const onLogin = () => {
  router.push({name: 'login'})
}

const onRegister = () => {
  dlgFlag.value = 2
  dlgMessage.value = '请扫描官方小程序二维码，在小程序个人中心完善个人资料后，即可在官网通过手机号进行登录。'
  showVip.value = true
}

const onLoginOut = () => {
  userLoginOut(store.state.userInfo.phone)
  sessionStorage.removeItem('userInfo')
  store.commit('updateState', [{key: 'userInfo', value: null}])
  router.push({name: 'home'})
}

const onShowMinProg = () => {
  dlgFlag.value = 1
  dlgMessage.value = ''
  showVip.value = true
}

const onOpenVip = () => {
  dlgFlag.value = 0
  dlgMessage.value = '请扫描官方小程序二维码，在小程序个人中心点击志愿卡进行开通。'
  showVip.value = true
}
</script>

<style>
html,
body,
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: 14px;
  background-color: #f5f4f8;
}

.el-dialog__title {
  font-size: 14px !important;
}

.el-form-item {
  margin-bottom: 10px !important;
}

.el-dialog__body {
  padding: 10px 20px !important;
}

.el-dialog__header {
  margin-right: 0 !important;
  background-color: #f7f7f7;
}

.el-menu--horizontal.el-menu {
  border-bottom: none !important;
}

.el-menu-item, .el-sub-menu__title, .is-active {
  font-size: 14px !important;
  font-weight: bold !important;
}

/**让下拉菜单半透明--start**/
/**
.el-popper.is-light {
  border: none !important;
  background: transparent !important;
}

.el-menu--popup {
  background: transparent !important;
}

.el-menu--popup .el-menu-item {
  background: rgba(0, 0, 0, 0.6) !important;
  font-size: 12px !important;
}

.el-menu--popup .el-menu-item:hover {
  background-color: #a2a2a2 !important;
}

.el-select-dropdown__wrap {
  background: #fff !important;
}
**/

/**让下拉菜单半透明--end**/

.wish-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  overflow: hidden;
  color: #fda0a0;
  border: 1px solid #d9d9d9;
  border-right: none;
  height: 38px;
  margin-left: 10px;
}

/* 定义光条的样式 */
.open-vip::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 30px;
  height: 100%;
  background: rgba(255, 255, 255, 0.5); /* 半透明白色 */
  transform: skewX(-20deg); /* 斜角效果 */
  animation: shine 0.8s linear infinite forwards;
}

/* 定义动画 */
@keyframes shine {
  0% {
    left: -49%;
  }
  100% {
    left: 90%;
  }
}

/* 设置 div 的样式 */
.open-vip {
  position: relative; /* 确保 ::before 定位相对于此 div */
  width: 150px;
  height: 40px;
  background-color: #409eff; /* 深色背景，以便光条明显 */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
}

.open-vip > span {
  font-size: 24px;
  font-weight: bold;
  margin-left: 5px;
}

/* 全局 CSS：禁止选中 */
.no-select {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  /* 禁止拖拽图片等元素 */
  -webkit-user-drag: none;
  user-drag: none;
}

/* 如果某些特定区域需要允许复制，可以单独覆盖 */
.allow-copy {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
</style>

<style scoped>
.menu-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
//padding: 0 15%; background-color: #409eff;
  border-bottom: 1px solid #fff;
}

.el-menu-bar {
  width: calc(70% - 400px);
}

.plus-bar {
  width: 100%;
  height: 30px;
}

.plus-content {
  display: flex;
  justify-content: space-between;
  width: 70%;
  height: 30px;
  margin: 0 auto;
}

.service-tel {
  display: flex;
  align-items: center;
  padding: 5px 0;
  color: #a1a1a1;
}

.service-tel > span {
  font-size: 18px;
  font-weight: bold;
  color: #409eff;
}

.plus-right {
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  width: 200px;
}

.menu-tools {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #fff;
  width: 415px;
}

.menu-tool-item {
  display: flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
}

.search-box {
  width: 100%;
  background-color: #fff;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
  margin: 0 auto;
}

.logo {
  width: 254px;
  height: 88px;
}

.logo > img {
  width: 254px;
  height: 88px;
}

.right-box {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  margin-left: 20px;
}

.u-color {
  display: flex;
  align-items: center;
  color: #fff700;
  margin-left: 20px;
}

.u-color span {
  margin-right: 10px;
}

.tips-img {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.tips-img img {
  width: 150px;
  height: 150px;
}
</style>
